import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import Ekomi from 'components/Stage/Ekomi';
import TuvCertificate from 'components/Stage/TuvCertificate';

interface TrustBannerProps {
  title: string;
}
export const TrustBanner = ({ title }: TrustBannerProps) => {
  return (
    <Box
      sx={(theme) => ({
        backgroundColor: 'grey.50',
        width: '100%',
        marginTop: 2,
        marginBottom: 2,

        [theme.breakpoints.up('md')]: {
          backgroundColor: 'transparent',
        },
      })}
    >
      <Container maxWidth="lg">
        <Box
          sx={(theme) => ({
            backgroundColor: 'grey.50',
            paddingY: 2,

            [theme.breakpoints.up('md')]: {
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: theme.spacing(1),
              padding: '32px min(15%, 180px)',
              gap: 7,
            },
          })}
        >
          <Typography variant="h2" suppressHydrationWarning>
            {title}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 4,
              flexShrink: 0,
              justifyContent: { xs: 'center', md: 'flex-start' },
              marginTop: { xs: 3, md: 0 },
              '& > *': {
                margin: { xs: '0 !important', md: 'initial' },
              },
            }}
          >
            <TuvCertificate />
            <Ekomi />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
